__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-rewards/v3_2_4/";